import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/pt';
import InsightcareHeader from './components/InsightcareHeader';
import InsightcareLocalFooter from './components/InsightcareLocalFooter';
import AuxRoutines from './AuxRoutines';
import ProgressBar from './components/Progress';
import Select from 'react-select';
// import PdfCentroCirurgico from './components/PdfCentroCirurgico';
//require('moment/locale/pt-BR');
import { BACKEND_URL } from './config/constants';

class PainelLeitosManutencao extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    this.state = {
      cycle: 0,
      totalCycles: 0,
      leitos: [],
      searchLeitos: [],
      filteredleitos: [],
      numberOfElements: 0,
      base: params.base,
      company: params.company,
      theme: (params.theme === 'dark' ? 'darkTheme' : 'lightTheme'),
      iconText: (params.theme === 'dark' ? '_dark' : ''),
      locationName: AuxRoutines.getLocationName(params.base, params.company),
      boolFoward: 1,
      boolPause: 0,
      interval: 0,
      intervalValue: 0,
      value: 0,
      test: '',

    };
    console.log(this.state.theme);
    this.loadRequiredData = this.loadRequiredData.bind(this)
  }

  componentDidMount() {
    //Carrega o local se existe
    if (this.state.theme === 'darkTheme') {
      document.body.style.backgroundColor = "black";
    }
    this.moveProgress();
    this.loadRequiredData().then(() => {
      this.setState({ appIsReady: true });
    });
  }

  async loadingBar(time) {
    return await new Promise(resolve => {
      this.setState({
        intervalValue: setInterval(async () => {
          resolve('load');
          const newValue = this.state.value + 1;
          if (newValue <= 100 && this.state.boolPause === 0 && this.state.filteredleitos.length !== 1) {
            this.setState({
              value: newValue,
            });
          }
        }, time),
      });
    });
  }

  moveProgress() {
    clearInterval(this.state.interval);
    clearInterval(this.state.intervalValue);
    if (this.state.boolPause === 0) {
      this.loadingBar(200).then(() => { console.log('loading') });
      this.setState({
        interval: setInterval(async () => {
          this.setState({
            value: 0,
          });
          this.loadRequiredData();
        }, 20000),
      });
    }
  }

  pauseProgress() {
    clearInterval(this.state.intervalValue);
    clearInterval(this.state.interval);
  }

  async loadRequiredData() {
    let sliceSize = 10;

    moment.locale('pt');
    if (this.state.cycle === this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY');
      let leitos = await this.requestData();
      let numberOfElements = leitos.length;
      let cycle = 1;
      let totalCycles = Math.ceil(numberOfElements / sliceSize);
      if (totalCycles === 0) {
        cycle = 0;
      }

      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: leitos,
          leitos: leitos.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles
        }
      );
    } else {
      if (this.state.totalCycles > 0) {
        this.setState({ cycle: this.state.cycle + 1, leitos: this.state.dashboardData.slice(0 + (sliceSize * this.state.cycle), sliceSize + (sliceSize * this.state.cycle)) })
      }
    }
  }

  changeCycle(boolFoward) {
    let sliceSize = 10;
    if (boolFoward === 0) {
      if (this.state.cycle === 1) {
        this.setState({ cycle: this.state.totalCycles, leitos: this.state.dashboardData.slice(0 + (sliceSize * (this.state.totalCycles - 1)), sliceSize + (sliceSize * (this.state.totalCycles - 1))) })
      } else {
        this.setState({ cycle: this.state.cycle - 1, leitos: this.state.dashboardData.slice(0 + (sliceSize * (this.state.cycle - 2)), sliceSize + (sliceSize * (this.state.cycle - 2))) })
      }
    } else if (boolFoward === 1) {
      this.loadRequiredData();
    }
    this.setState({
      value: 0,
    });
  }

  actionPause(boolPause) {
    if (boolPause === 1) {
      this.setState({ boolPause: boolPause });
      this.pauseProgress();
    } else {
      this.setState({ boolPause: 0 });
      this.moveProgress();
    }
  }

  async requestData() {
    let returnData = this.state.leitos; //In case request fails
    //console.log(this.state.base)
    let url = BACKEND_URL + '/command-center/painel-leitos-manutencao?base=' + this.state.base;
    if (this.state.company !== undefined && this.state.company !== null) {
      url = url + '&company=' + this.state.company;
    }
    let response = await axios.get(url);
    if (response.data && response.data.Status === true) {
      returnData = response.data.ResponseData;
    }

    this.setState({
      searchLeitos: returnData,
      filteredleitos: this.state.filteredleitos !== [] ? this.state.filteredleitos : returnData,
    });

    return returnData;
  }

  textoGrupoleitos(ciclo, totalCiclos, totalElementos) {
    if (this.state.filteredleitos.length === 1) {
      return "Mostrando de 1 a 1, de 1 leito";
    }
    else {
      var de = (ciclo <= 1) ? ciclo : (ciclo - 1) * 10;
      var ate = (ciclo === totalCiclos) ? totalElementos : ciclo * 10;
      return "Mostrando de " + de + " a " + ate + ", de " + totalElementos + " leitos";
    }

  }


  render() {
    return (
      <div className={"App " + this.state.theme}>
        <InsightcareHeader title="Leitos em Manutenção" theme={this.state.theme} />
        <main className={"content " + this.state.theme} id="panel1Styled">
          <ProgressBar value={this.state.value} max={100} />
          <div className={"inforow " + this.state.theme}>
            <div className={'inforow right ' + this.state.theme}>
              <button className={'buttonIcon ' + this.state.theme}><img src={"/img/icon_arrow_left" + this.state.iconText + ".svg"} alt="" onClick={() => this.changeCycle(0)} /></button>
              <button className={'buttonIcon ' + this.state.theme}><img src={"/img/icon_arrow_right" + this.state.iconText + ".svg"} alt="" onClick={() => this.changeCycle(1)} /></button>
              <button className={'buttonIcon ' + this.state.theme}><img src={"/img/icon_pause" + this.state.iconText + ".svg"} alt="" onClick={() => this.actionPause(this.state.boolPause === 1 ? 0 : 1)} /></button>
              <div className='infoText'>{this.textoGrupoleitos(this.state.cycle, this.state.totalCycles, this.state.numberOfElements)}</div>
            </div>

            <div className={'inforow left ' + this.state.theme}>
              <div className='infoText'>Agora são {this.state.currentDateHour}</div>
              {/* <PdfCentroCirurgico title={"Leitos em Manutenção"} list={(this.state.filteredleitos.length === 0) ? this.state.searchLeitos : this.state.filteredleitos} theme={this.state.theme} /> */}
              <form>
                <div className={'buttonSearch ' + this.state.theme}>
                  <img src={"/img/icon_search" + this.state.iconText + ".svg"} alt="" />
                  <Select className={'selectSearch ' + this.state.theme}
                    placeholder="Busque por um leito ou andar..."
                    options={
                      this.state.searchLeitos.map(opt => ({ 
                        key: opt.CODIGOLEITO, 
                        label: opt.LEITO, 
                        value: opt.CD_AVISO_CIRURGIA,
                        nome: opt.LEITO,
                      }))}
                    isClearable={true}
                    onChange={ opt => {
                      if (opt !== null && opt !== '') {
                        const pessoa = this.state.searchLeitos.find((elem) => (elem.LEITO === opt.nome || elem.UNIDADEINTERNACAO === opt.cirurgia));
                        if (pessoa) {
                          this.setState({
                            filteredleitos: [pessoa]
                          });
                        } else {
                          this.setState({
                            filteredleitos: this.state.searchLeitos,
                          });
                        }
                      } else {
                        this.setState({
                          filteredleitos: this.state.searchLeitos,
                        });
                      }
                    }}
                  />
                </div>
              </form>
            </div>
          </div>

          <table className="table table-striped">
            <thead>
              <tr>
                <th>Status</th>
                <th>Empresa</th>
                <th>Unidade</th>
                <th>Leito </th>
                <th>Tempo</th>
              </tr>
            </thead>
            <tbody className={this.state.theme}>
              {
              (this.state.filteredleitos.length === 1
                ? this.state.filteredleitos 
                : this.state.leitos)
              .map((data) => {
                let color = '';
                let statusClass = "waiting";
                let tdClassFarm = "";
                let spanClassFarm = "";
                let name = data.LEITO;
                let empresa = data.EMPRESA;
              
                let horario = data.DATAHORAMANUTENCAO;
                let unidade = data.UNIDADEINTERNACAO;
          
                let key = "tr-" + data.CODIGOLEITO;
                let tempo = data.TEMPO
                if (tempo>10080) {
                  statusClass = 'canceled';
                  color = 'red';
                }
                let dias =tempo/1440;
                dias =Math.floor(dias);

                return (
                  <tr key={key} className={statusClass}>
                    {/* <td><div className="alert-label"></div></td> */}
                    <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" className='alert-content'> <div className="alert-label" /></td>
                    <td style={{ color: color }} align="left">{empresa}</td>
                    <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{unidade}</td>
                    <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" className='infoText'><b>{name}</b></td>
                    <td className={tdClassFarm} style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"><span className={spanClassFarm}></span>{dias} dias</td>
                  </tr>
                )
              })
              }

            </tbody>
          </table>
        </main>

        <InsightcareLocalFooter hospitalName={this.state.locationName} theme={this.state.theme} />
      </div>
    );
  }
}

export default PainelLeitosManutencao;
